<template>
  <div id="app" class="loginimg" style="display: flex; flex-direction: column;">
    <div style="margin: auto 0; width: 100%;">

    <CustomerLogo />

    <div class="row justify-content-center">
      <div class="col-10 col-md-6 col-lg-5 col-xl-4 align-self-center justify-content-center row">
        <!-- Show expired code message if code is expired -->
        <template v-if="codeExpired">
          <div class="white--text col-12 text-h4 text-center">
            {{ $t('invitation_code_expired') }}
          </div>

          <div class="white--text col-10 text-center mt-4 mb-6" style="opacity: 0.85; font-size: 14px;">
            {{ $t('invitation_code_expired_message') }}
          </div>

          <div class="pa-0 col-10 mb-4">
            <v-btn
              class="w-100 white--text signinbtn"
              style="padding: 27px !important; background-color: #161616 !important;"
              outlined
              tile
              @click="resendInvitation"
              :loading="isResending">
              {{ $t('resend_invitation') }}
            </v-btn>
          </div>

          <!-- Back to login link -->
          <div class="pa-0 col-10 mb-8 text-center">
            <span class="white--text" style="opacity: 0.7; font-size: 14px;">
              {{ $t('back_to_login') }}
            </span>
            <v-btn
              text
              small
              class="white--text ml-1"
              style="text-transform: none; font-size: 14px; text-decoration: underline;"
              @click="$router.push('/login')">
              {{ $t('log_in') }}
            </v-btn>
          </div>
        </template>

        <!-- Show normal password form if code is valid -->
        <template v-else>
          <div class="white--text col-12 text-h4 text-center">
            {{ $t('welcome_to_muniman') }}
          </div>

          <div class="white--text col-10 text-center mt-4 mb-6" style="opacity: 0.85; font-size: 14px;">
            {{ $t('invitation_account_created') }}
          </div>

        <div class="col-10 pa-0 mt-6 mb-4">
          <div class="white--text mb-2 text-uppercase" style="font-size: 12px; letter-spacing: 0.86px; opacity: 0.85;">
            {{ $t('password') }}
          </div>
          <v-text-field
            class="white rounded-0 logininput"
            :type="showPassword ? 'text' : 'password'"
            :label="$t('password')"
            outlined
            hide-details="auto"
            v-model="password"
            @input="errors.password = false"
            :error="errors.password">
            <template v-slot:append>
              <v-icon
                small
                @click="showPassword = !showPassword"
                class="cursor-pointer"
              >
                {{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}
              </v-icon>
            </template>
          </v-text-field>
          <div v-if="errors.password" class="error--text" style="font-size: 12px; margin-top: 4px;">
            {{ passwordErrors }}
          </div>
        </div>

        <div class="col-10 pa-0 mb-4">
          <div class="white--text mb-2 text-uppercase" style="font-size: 12px; letter-spacing: 0.86px; opacity: 0.85;">
            {{ $t('confirm_password') }}
          </div>
          <v-text-field
            class="white rounded-0 logininput"
            :type="showConfirmPassword ? 'text' : 'password'"
            :label="$t('confirm_password')"
            outlined
            hide-details="auto"
            v-model="confirmPassword"
            @input="errors.confirmPassword = false"
            :error="errors.confirmPassword">
            <template v-slot:append>
              <v-icon
                small
                @click="showConfirmPassword = !showConfirmPassword"
                class="cursor-pointer"
              >
                {{ showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye' }}
              </v-icon>
            </template>
          </v-text-field>
          <div v-if="errors.confirmPassword" class="error--text" style="font-size: 12px; margin-top: 4px;">
            {{ $t('passwords_do_not_match') }}
          </div>
        </div>

        <!-- Data Privacy Checkbox -->
        <div data-field="privacyPolicy" class="pa-0 col-10 mb-6">
          <v-checkbox
              v-model="privacyPolicyAccepted"
              :error="errors.privacyPolicy"
              hide-details="auto"
              @change="errors.privacyPolicy = false"
              dark
              color="white"
              class="mt-0">
            <template v-slot:label>
              <span class="white--text" style="font-size: 14px; opacity: 0.9;">
                {{ $t('accept_privacy_policy') }}
                <PrivacyPolicy :link-text="$t('privacy_policy_title')" />
                {{ $t('accept_privacy_policy_terms_separator') }}
                <TermsAndConditions :link-text="$t('terms_and_conditions_title')" />
              </span>
            </template>
          </v-checkbox>
        </div>

        <!-- Set Password Button -->
        <div class="pa-0 col-10 mb-4">
          <v-btn
            class="w-100 white--text"
            :class="isFormValid ? 'signinbtn' : ''"
            :style="isFormValid ? 'padding: 27px !important; background-color: #161616 !important;' : 'padding: 27px !important; background-color: #666666 !important; border: 1px solid #666666 !important; cursor: not-allowed !important;'"
            outlined
            tile
            :disabled="!isFormValid"
            @click="setPassword"
            :loading="isLoading">
            {{ $t('set_password') }}
          </v-btn>
        </div>

        <!-- Back to login link -->
        <div class="pa-0 col-10 mb-8 text-center">
          <span class="white--text" style="opacity: 0.7; font-size: 14px;">
            {{ $t('back_to_login') }}
          </span>
          <v-btn
            text
            small
            class="white--text ml-1"
            style="text-transform: none; font-size: 14px; text-decoration: underline;"
            @click="$router.push('/login')">
            {{ $t('log_in') }}
          </v-btn>
        </div>

          <!-- Error message -->
          <div v-if="error" class="col-10 pa-0 mt-4">
            <v-alert type="error" outlined>
              {{ error }}
            </v-alert>
          </div>
        </template>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import PrivacyPolicy from './custom/PrivacyPolicy.vue';
import TermsAndConditions from './custom/TermsAndConditions.vue';
import CustomerLogo from "@/components/custom/CustomerLogo.vue";

export default {
  name: 'Invitation',
  components: {
    CustomerLogo,
    PrivacyPolicy,
    TermsAndConditions
  },

  data() {
    return {
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      privacyPolicyAccepted: false,
      errors: {
        password: false,
        confirmPassword: false,
        privacyPolicy: false
      },
      error: null,
      isLoading: false,
      isResending: false,
      mail: null,
      code: null,
      codeExpired: false
    };
  },

  computed: {
    isFormValid() {
      return this.password && this.confirmPassword &&
             this.password === this.confirmPassword &&
             this.password.length >= 8 &&
             this.mail !== null &&
             this.code !== null &&
             this.privacyPolicyAccepted;
    },

    passwordErrors() {
      if (this.password.length < 8) {
        return this.$t('password_too_short');
      }
      if (!this.hasUpperCase()) {
        return this.$t('password_needs_uppercase');
      }
      if (!this.hasLowerCase()) {
        return this.$t('password_needs_lowercase');
      }
      if (!this.hasNumber()) {
        return this.$t('password_needs_number');
      }
      if (!this.hasSpecialChar()) {
        return this.$t('password_needs_special_char');
      }
      return '';
    }
  },

  mounted() {
    this.initializeFromQuery();
    // Validate the code when the page loads
    if (this.mail && this.code) {
      this.validateCodeOnLoad();
    }
  },

  methods: {
    initializeFromQuery() {
      try {
        const mailParam = this.getQueryParam("m=", window.location.search).replaceAll("%3D", "");
        const codeParam = this.getQueryParam("c=", window.location.search).replaceAll("%3D", "");

        if (!mailParam || !codeParam) {
          this.error = this.$t('invalid_invitation_link');
          return;
        }

        this.mail = atob(mailParam);
        this.code = atob(codeParam);
      } catch (e) {
        this.error = this.$t('invalid_invitation_link');
      }
    },

    getQueryParam(searchWord, query) {
      const searchWordPosition = query.indexOf(searchWord);

      if (searchWordPosition >= 0) {
        const start = searchWordPosition + searchWord.length;
        const separatorPosition = query.indexOf("&", start);
        const end = separatorPosition === -1 ? query.length : separatorPosition;
        return query.substr(start, end - start);
      }
      return "";
    },

    hasUpperCase() {
      return /[A-Z]/.test(this.password);
    },

    hasLowerCase() {
      return /[a-z]/.test(this.password);
    },

    hasNumber() {
      return /[0-9]/.test(this.password);
    },

    hasSpecialChar() {
      return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.password);
    },

    validate() {
      this.errors = {
        password: false,
        confirmPassword: false,
        privacyPolicy: false
      };

      if (!this.password) {
        this.errors.password = true;
        return false;
      }

      if (this.password.length < 8) {
        this.errors.password = true;
        return false;
      }

      if (!this.hasUpperCase() || !this.hasLowerCase() || !this.hasNumber() || !this.hasSpecialChar()) {
        this.errors.password = true;
        return false;
      }

      if (!this.confirmPassword) {
        this.errors.confirmPassword = true;
        return false;
      }

      if (this.password !== this.confirmPassword) {
        this.errors.confirmPassword = true;
        return false;
      }

      if (!this.privacyPolicyAccepted) {
        this.errors.privacyPolicy = true;
        return false;
      }

      return true;
    },

    setPassword() {
      if (!this.validate()) {
        if (!this.privacyPolicyAccepted) {
          this.$noty.error('<i class="fas fa-minus-circle mr-3"></i>' + this.$t('privacy_policy_required'));
        } else {
          this.$noty.error('<i class="fas fa-minus-circle mr-3"></i>' + this.$t('password_requirements_not_met'));
        }
        return;
      }

      this.isLoading = true;
      this.error = null;

      const request = {
        code: this.code,
        password: this.password,
        confirmPassword: this.confirmPassword
      };

      this.$axios.patch('/api/users/mail/' + this.mail + '/password', request)
        .then(response => {
          this.$noty.success('<i class="fas fa-check-circle mr-3"></i>' + this.$t('password_set_successfully'));
          // Redirect to login after delay
          setTimeout(() => {
            this.$router.push('/login');
          }, 1000);
        })
        .catch(error => {
          console.error('Invitation completion error:', error);
          let errorMsg = this.$t('password_set_failed');

          if (error.response) {
            if (error.response.status === 400) {
              errorMsg = this.$t('invalid_password_or_code');
            } else if (error.response.status === 404) {
              errorMsg = this.$t('ERROR_USER_BY_MAIL_NOT_FOUND');
            } else if (error.response.status === 406) {
              errorMsg = this.$t('ERROR_PASSWORD_TOO_WEAK');
            } else if (error.response.status === 409) {
              errorMsg = this.$t('ERROR_INVALID_RESET_CODE');
            } else if (error.response.status === 412) {
              errorMsg = this.$t('ERROR_INVITATION_CODE_EXPIRED');
            }
          }

          this.error = errorMsg;
          this.$noty.error('<i class="fas fa-minus-circle mr-3"></i>' + errorMsg);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async validateCodeOnLoad() {
      try {
        const response = await this.$axios.get(
          `/api/users/mail/${this.mail}/invitation/validate`,
          { params: { code: this.code } }
        );

        if (response.data.status === 'valid') {
          this.codeExpired = false;
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status === 412) {
            // Code expired
            this.codeExpired = true;
          } else if (error.response.status === 400 && error.response.data.status === 'already_completed') {
            // User has already completed registration
            this.$router.push('/login');
            this.$noty.info(
              '<i class="fas fa-info-circle mr-3"></i>' +
              this.$t('registration_already_completed')
            );
          } else if (error.response.status === 409 || error.response.status === 404) {
            // Invalid code or not found
            this.error = this.$t('invalid_invitation_link');
            this.codeExpired = true;
          }
        } else {
          console.error('Validation error:', error);
        }
      }
    },

    async resendInvitation() {
      this.isResending = true;
      this.error = null;

      try {
        const lang = this.$i18n.locale || 'de';
        const response = await this.$axios.post(
          `/api/users/mail/${this.mail}/invitation/resend`,
          null,
          { params: { lang } }
        );

        if (response.data.status === 'sent') {
          this.$noty.success(
            '<i class="fas fa-check-circle mr-3"></i>' +
            this.$t('invitation_resent_successfully')
          );

          // After 2 seconds, redirect to login
          setTimeout(() => {
            this.$router.push('/login');
          }, 2000);
        }
      } catch (error) {
        console.error('Resend invitation error:', error);
        let errorMsg = this.$t('UNEXPECTED_ERROR');

        if (error.response) {
          if (error.response.status === 404) {
            errorMsg = this.$t('ERROR_USER_BY_MAIL_NOT_FOUND');
          } else if (error.response.status === 409) {
            errorMsg = this.$t('ERROR_IP_BLOCKED');
          } else if (error.response.status === 400) {
            // Registration already completed
            errorMsg = this.$t('registration_already_completed');
            // Redirect to login after showing error
            setTimeout(() => {
              this.$router.push('/login');
            }, 2000);
          }
        }

        this.error = errorMsg;
        this.$noty.error('<i class="fas fa-minus-circle mr-3"></i>' + errorMsg);
      } finally {
        this.isResending = false;
      }
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.error--text {
  color: #ff6363 !important;
}
</style>
